'use strict';

import App from 'App';
import { SAIView } from '../../Additions';
import CClientConfiguration from 'parametrage/CClientConfiguration';
import ColorUtils from 'utils/ColorUtils';
let $ = require('jquery');

/**
 * A criteria the user may pick, with the label shown to him and the human readable value it
 * currently holds, if any.
 */
interface CriteriaChoice {
    datafieldId: string;
    label: string;
    value?: string;
}

/**
 * Asks the user which criteria he wants to set. Every criteria declared by the filter is
 * offered, including the ones already holding a value: picking one again is how the user
 * changes his selection, without having to remove it first. The current value of each
 * criteria is displayed under its label, so that the popup also tells what is applied.
 */
class CriteriaChoicePopup extends SAIView {
    //Displayed under a criteria that holds no value yet
    private static readonly NO_VALUE_LABEL = 'Aucune sélection';

    private uniqId: number;
    private choicesList: JQuery<HTMLElement>;

    initialize(options) {
        this.checkMandatoryParameter(options, 'criterias', 'The criterias to choose from');
        this.checkMandatoryParameter(options, 'title', 'The title of the popup');
        this.template = require('templates/modalPopup/ModalPopup.ejs');
        this.uniqId = parseInt(Math.random()*10000 + '');
    }

    render(): any {
        this.checkInitialized();

        this.$el = $(this.template({
            operationTitle: this.parameters.title,
            logo: CClientConfiguration.getGlobalImage(CClientConfiguration.APP_LOGO_BLACK),
            operationColor: App.getConfig().appTheme,
            uniqId: this.uniqId,
            allowDocs: false,
            hideSpinner: true,
            hideCloseButton: false,
            hideTitle: false,
            extraClass: 'criteria-choice-popup',
            allowDismiss: true,
            colorUtils: ColorUtils
        }));

        this.choicesList = this.$el.find('.innerView');
    }

    display(): void {
        let me = this;
        this.render();

        this.$el.on('shown.bs.modal', function() {
            me.displayChoices();
        });

        this.$el.on('hidden.bs.modal', function() {
            $('#'+me.uniqId).remove();
        });

        this.$el.modal('show');
    }

    hide(): void {
        this.$el.modal('hide');
    }

    private displayChoices(): void {
        for(let key in this.parameters.criterias) {
            let criteria: CriteriaChoice = this.parameters.criterias[key];
            let hasValue = criteria.value !== undefined && criteria.value !== '';

            //The labels come from the parametrage and the values from the data: both are
            //inserted as text, never as markup
            let entry = $('<div class="criteriaEntry"></div>').attr('data-id', criteria.datafieldId).toggleClass('active', hasValue);
            $('<span class="criteriaIcon"><i class="fa fa-filter" aria-hidden="true"></i></span>').appendTo(entry);
            let text = $('<span class="criteriaText"></span>').appendTo(entry);
            $('<span class="criteriaLabel"></span>').text(criteria.label).appendTo(text);
            $('<span class="criteriaValue"></span>').text(hasValue ? criteria.value : CriteriaChoicePopup.NO_VALUE_LABEL).appendTo(text);
            $('<i class="fa fa-chevron-right criteriaChevron" aria-hidden="true"></i>').appendTo(entry);
            this.choicesList.append(entry);
        }

        this.choicesList.find('.criteriaEntry').click(this.onCriteriaClick.bind(this));
    }

    private onCriteriaClick(evt): void {
        this.trigger('criteriaSelected', $(evt.currentTarget).data('id'));
    }
}

export default CriteriaChoicePopup;
export { CriteriaChoice };
